import { Avatar, Image } from '@chakra-ui/react';
import DefaultAvatar from '../assets/img/DefaultAvatar.png';

export const AvatarWithDefaultIcon = ({ src, ...restProps }: { src?: string; [key: string]: any }) => {
  return (
    <Avatar
      size='md'
      icon={<Image src={DefaultAvatar} alt="Default avatar" />}
      src={src}
      borderWidth={1}
      borderColor='brand.formInputBgColor'
      bg='transparent'
      {...restProps}
    />
  );
};
